import { getCurrentInstance } from 'vue'
import Vue from 'vue/types/umd'

export function useCurrentInstance() {
  const { proxy } = getCurrentInstance() as { proxy: Vue }
  return proxy
}